module.exports = __webpack_public_path__ + "static/media/vertex_exploded_GreatDodecahedron_centered_at_vertex.6b3ecfeb.gif";